import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from "@iconify/react";
import { setUserInfo } from "@/redux/actions/home";
import useDispatchAction from "@/hooks/useDisptachAction";
import { APIUserCategorySave, APIGetUserInfo } from "@/api";
import { fetchCategoryFirst } from '@/redux/actions/home-mobile';
import useLanguage from '@/hooks/useLanguage';
import styles from './index.module.scss';

const SelectTagPopup = ({ type, isVisible, closePopup, confirmPopup }) => {
  const { t } = useLanguage();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState([]);
  const dispatchAction = useDispatchAction({ setUserInfo });
  const { categoryFirst } = useSelector((state) => {
    return state.categoryFirstInfo;
  });

  const handleClick = (id) => {
    console.log('~id', id, selected, selected?.includes(id), !selected);
    if (selected?.includes(id)) {
      // 已选中，取消
      setSelected(selected?.filter((item) => item !== id));
    } else if (selected?.length < 3) {
      // 未选中且未达到上限
      setSelected([...selected, id]);
    } else if (!selected) {
      // 初始状态
      setSelected([id]);
    }
  };

  const confirm = () => {
    console.log('~selected', selected);
    APIUserCategorySave(JSON.stringify({ categoryIds: selected ? selected : [] })).then(resp => {
      closePopup();
      setSelected([]);
      const token = localStorage.getItem("token");
      if (token) {
        APIGetUserInfo().then(resp => {
          if (resp.data.user) {
            dispatchAction.setUserInfo(resp.data.user);
          }
          localStorage.setItem("user", JSON.stringify(resp.data.user));
          if (type === 'profile') {
            confirmPopup();
          }
        });
      }
    }).catch(e => {
      console.log('~e', e);
    });
  };

  useEffect(() => {
    if (isVisible) {
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
      const userCategorys = typeof window !== "undefined" ? JSON.parse(localStorage?.getItem("user"))?.userCategorys : [];
      const categoryIds = userCategorys?.map(name => {
        const found = categoryFirst?.find(item => item.name === name);
        return found ? found.categoryId : null;
      })
        .filter(id => id !== null);
      setSelected(categoryIds);
    } else {
      // 恢复页面滚动
      document.body.style.overflow = '';
    }
    // 在组件卸载时恢复页面滚动
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  useEffect(() => {
    if (categoryFirst?.length === 0 && type === 'profile') {
      dispatch(fetchCategoryFirst());
    }
  }, [categoryFirst]);

  return (
    isVisible && <div className={styles.overlay}
      onClick={(e) => {
        e.preventDefault();
        if (type === 'home') {
          confirm();
        } else {
          closePopup();
          setSelected([]);
        }
      }}
      onTouchMove={(e) => {
        e.preventDefault(); // 阻止默认的触摸移动行为，防止页面滚动
      }}
    >
      <div className={`${styles.popup} 
      ${isVisible ? styles['popup-enter'] : styles['popup-exit']}`}
        onClick={(e) => e.stopPropagation()} // 阻止事件冒泡，避免点击内容关闭 Popup
      >
        <div className={styles.header}>
          <div className={styles.headerLeft}>{t('selectTag_h5.title')}</div>
          <div className={styles.headerRight} onClick={(e) => {
            e.preventDefault();
            if (type === 'home') {
              confirm();
            } else {
              closePopup();
              setSelected([]);
            }
          }}>
            <Icon icon='line-md:close' className={styles.headerRightIcon} />
          </div>
        </div>
        <div className={styles.tagList}>
          {categoryFirst?.map((item, index) => (
            <div
              key={index}
              className={`${styles.tagItem} ${selected?.includes(item.categoryId) ? styles.selected : ""}`}
              onClick={() => handleClick(item.categoryId)}
            >
              {item.name}
            </div>
          ))}
        </div>
        <div className={styles.footer}>
          <div className={styles.reset} onClick={() => {
            setSelected([]);
          }}>{t('selectTag_h5.reset')}</div>
          <div className={styles.confirm} onClick={confirm}>{t('selectTag_h5.confirm')}</div>
        </div>
      </div>
    </div>
  );
};

export default SelectTagPopup;